// TODO: Consolidate all marketplace utilities in this file
// - Header.tsx#L18
// - links.ts#L3
const TLD_TO_MARKETPLACE = {
    '.ca': 'CA',
    '.com': 'US',
};
/**
 * Returns the marketplace ID based on the search params or domain.
 * Priority: searchParams > domain-based detection > 'US' fallback
 */
export const getMarketplace = (searchParams) => {
    const fromParams = searchParams.get('marketplaceId');
    if (fromParams)
        return fromParams;
    const hostname = window.location.hostname;
    const tld = Object.keys(TLD_TO_MARKETPLACE).find((t) => hostname.endsWith(t));
    return tld ? TLD_TO_MARKETPLACE[tld] : 'US';
};
